// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"b913949f","57":"d9dde0f2","90":"333b93e5","95":"26f5645f","108":"e5bb65f1","474":"8084379a","604":"c2333117","937":"5022837c","981":"8f528eb0"}[chunkId] + ".chunk.css";
};